import React, { createContext, useContext, useReducer } from "react";
import { CategoryInitialState } from "./container/category/CategoryReducer";
import { AuthInitialState } from "./Page/LogIn/reducer";
import { ActiveMenuInitialState } from "./container/Menu/activeMenuReducer";
import { RoleInitialState } from "./container/Role/RoleReducer";
import { FoodInitialState } from "./container/Food/FoodReducer";
import { UserInitialState } from "./container/user/UserReducer";
import { OrderInitialState } from "./container/Order/OrderReducer";
import { foodReportInitialState } from "./container/FoodReport/FoodReportReducer";
import { CompanyInitialState } from "./container/Company/CompanyReducer";

import { applyMiddleware } from "./middleware";

import reducer, { IReducer } from "./reducer";
import { PermissionInitialState } from "./container/permission/permissionReducer";
// import { menuInitialState, menuReducer } from "./container/Menu/MenuReducer";
// import { menuInitialState } from "./container/Menu/MenuReducer";
import { menuInitialState } from "./container/Menu/MenuReducer";
import { complainInitialState } from "./container/Complain/ComplainReducer";
import { vatInitialState } from "./container/VAT/vatReducer";
import {
  AdminUserInitialState,
  adminUserReducer,
} from "./container/AdminUser/AdminUserReducer";
import { SCmpUserReportInitialState } from "./container/SCmpUserReport/SCmpUserReport";
export const Context = createContext<
  [state: IReducer, dispatch: (action: any) => void]
>([
  {
    foodReportReducer: foodReportInitialState,
    authReducer: AuthInitialState,
    categoryReducer: CategoryInitialState,
    activeMenuReducer: ActiveMenuInitialState,
    roleReducer: RoleInitialState,
    foodReducer: FoodInitialState,
    userReducer: UserInitialState,
    companyReducer: CompanyInitialState,
    permissionReducer: PermissionInitialState,
    menuReducer: menuInitialState,
    orderReducer: OrderInitialState,
    complainReducer: complainInitialState,
    vatReducer: vatInitialState,
    adminUserReducer: AdminUserInitialState,
    SCmpUserReportReducer:  SCmpUserReportInitialState
  },
  () => {},
]);

const combinedReducers = (state: any = {}, action: any = {}) => {
  // console.log("Reducer",reducer)0

  return Object.assign(
    {},
    ...Object.keys(reducer).map((k) => ({ [k]: reducer[k](state[k], action) }))
  );
};

export default function Provider({ children }: any) {
  const [state, dispatch] = useReducer(combinedReducers, combinedReducers({}));

  return (
    <Context.Provider value={[state, applyMiddleware(dispatch)]}>
      {children}
    </Context.Provider>
  );
}

export const useStore = () => useContext(Context);
